import React, { useCallback } from "react";
import { useAsync } from "react-async";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react-lite";

import usePageTitle from "../../services/page-title/PageTitleKey";
import { configuration } from "../../services/configuration/ConfigurationService";
import { translationService } from "../../services/translation/TranslationService";

export default observer(function Head() {
  const { pageTitleKey, pageTitleContext } = usePageTitle();
  const { data: configurationContent, isPending } = useAsync({ promiseFn: configuration.get });

  const getTranslatedPageTitle = useCallback(() => {
    if (pageTitleKey) {
      if (pageTitleContext) return translationService.translate(pageTitleKey, pageTitleContext);
      else return translationService.translate(pageTitleKey);
    } else return undefined;
  }, [pageTitleContext, pageTitleKey]);

  const getFullPageTitle = useCallback(() => {
    if (isPending) return "";

    return pageTitleKey
      ? `${configurationContent.browser_title} - ${getTranslatedPageTitle()}`
      : `${configurationContent.browser_title}`;
  }, [configurationContent, isPending, pageTitleKey, getTranslatedPageTitle]);

  return !isPending ? (
    <Helmet>
      <title>{getFullPageTitle()}</title>
      {configurationContent.hotjar_id && (
        <script>
          {`
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:${configurationContent.hotjar_id},hjsv:${configurationContent.hotjar_sv}};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
        </script>
      )}
    </Helmet>
  ) : null;
});
